const iyfaaoPrice = {

    "P01":20,
    "P02":20,
    "P03":20,
    "P04":20,
    "P05":20,
    "P06":20,

    "T01":20,
    "T02":20,
    "T03":20,
    "T04":20,
    "T05":20,
    "T06":20,

    "C-1":47,
    "C-2":47,
    "C-3":47,

    "SC-1":55,
    "SC-2":55,
    "SC-3":55,
    "SC-4":65,
    "SC-5":65,
    "SC-6":75,

    "SH-1":55,
    "SH-2":55,
    "SH-3":55,
    "SH-4":65,
    "SH-5":65,
    "SH-6":75,

    "TEST":0.01,
}

export default iyfaaoPrice;